<template>
  <div style="min-height: 100vh">
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <topIcon :template="dominItem.templateId"  :nationId="dominItem.nationId" noAbout="noAbout"></topIcon>
    </div>
    <div>
      <div class="category" :class="`${dominItem.templateId}`" v-if="dominItem.templateId === 'temp1'">
        <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">{{ dominItem.logoName || 'Logo' }}</div>
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
      </div>
      <div class="category" :class="`${dominItem.templateId}`" v-else>
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
        <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">{{ dominItem.logoName || 'Logo' }}</div>
      </div>
    </div>




    <div style="padding: 0 20%;">
      <div class="baseball-article-page">
        <!-- 文章主体部分 -->
        <div class="article-main">
          <h1 class="article-title">{{ bestInfo.articleTitle }}</h1>

          <span class="time">
          <img src="@/assets/icon/time_fill.png" alt="">
<!--        <span style="margin-left: 20px">{{ bestInfo.uploadTime }}</span>-->
        <img src="@/assets/icon/eyess.png" style="margin-left: 20px" alt="">
        <span class="number">{{ bestInfo.articleReadNum }}</span>
      </span>


          <img
              v-if="bestInfo.articleImage"
              :src="bestInfo.articleImage"
              class="article-img"
          />

          <div class="article-meta">
            <img v-if="dominItem.templateId === 'temp1'" src="@/assets/temp1.jpg" alt="" class="author-logo"/>
            <img v-if="dominItem.templateId === 'temp2'" src="@/assets/temp2.jpg" alt="" class="author-logo"/>
            <img v-if="dominItem.templateId === 'temp3'" src="@/assets/temp3.jpg" alt="" class="author-logo"/>
            <div class="meta-info">
              <span class="author">{{ bestInfo.updateBy || $t('con_Editor')  }}</span>
<!--              <span class="publish-date">{{ bestInfo.uploadTime }}</span>-->
            </div>
          </div>


          <p class="photo-credit">{{ bestInfo.articleTitle }}</p>

          <div style="margin-top: 30px; text-align: center" v-for="item in videoList">
            <video ref="videoRef" :src="item.url" width="650" height="400" controls ></video>
          </div>
          <div class="detail" v-html="bestInfo.articleContent"></div>
        </div>
        <!-- 最新文章侧边栏 -->
<!--        <div class="sidebar">-->
<!--          <h2 class="sidebar-title">{{ $t('con_hot_con') }}</h2>-->
<!--          <div class="latest-post" v-for="item in latestNewsList" @click="toDetail(item.articleShortName)">-->
<!--            <img-->
<!--                :src="item.articleImage"-->
<!--                class="article-img"-->
<!--            >-->
<!--            <h3 class="twoHde">{{ item.articleTitle }}</h3>-->
<!--&lt;!&ndash;            <p class="post-date" style="margin-bottom: 15px">{{ item.uploadTime }}</p>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
      </div>

    <whileIcon v-if="dominItem.nationId !== 'cn'" centesr="centesr"></whileIcon>

    </div>


    <div class="buttom">

      <div class="line1">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div class="logo" style="color: #fff">{{ dominItem.logoName || 'Logo' }}</div>
          <div class="explore">
            <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer">{{ item.label }}</span>
          </div>
          <img v-if="dominItem.nationId !== 'cn'" style="width: 30px; height: 30px " v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">

        </div>
      </div>
      <footers is00="is00"  :articleListlast="articleListlast"></footers>

    </div>
  </div>
</template>

<script>
import {format} from "date-fns";
import whileIcon from "@/components/icons/whileicon.vue"
import topIcon from "@/components/icons/small.vue";
import footers from "@/components/footContent/index.vue"
import {getContentList, getInfo, getLatestNews} from "@/api";
import {Base64} from "js-base64";

export default {
  name: "index",
  components: {topIcon, whileIcon, footers},

  props: {
    dominItem: Object
  },
  data() {
    return {
      bestInfo:{},
      articleListlast:[],
      latestNewsList: [],
      template: 'temp2',
      nowDate: undefined,
      current: 1,
      nodata: false,
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],

      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.current = Number(this.$route.query.type)
    this.nowDate = format(new Date(), this.$t('con_format'))

    this.getArticleListlast()
    this.getLatestNewsList()
    this.getPageInfo(this.$route.params.name)
  },
  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.$router.push(`/?type=${item}`)
    },

    openLink(link) {
      window.open(link)
    },

    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    },

    // 根据文章id获取文章详情
    getPageInfo(name) {
      this.nodata = true
      getInfo({name: name, articleNationId: this.dominItem.nationId, domain: this.dominItem.domainName}).then(res => {
        let Base64 = require('js-base64').Base64;
        this.bestInfo = res.data.articleInfo
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime),  this.$t('con_format'))
        this.bestInfo.articleContent = Base64.decode(this.bestInfo.articleContent);
        this.nextChapter = res.data.nextChapter
        this.videoList = JSON.parse(this.bestInfo.remark)
        this.previousPost = res.data.previousPost
        this.recommendArticle = res.data.recommendArticle
        this.nodata = false
        this.bestInfo.articleImage = this.bestInfo.articleImage ? this.bestInfo.articleImage :
            JSON.parse(localStorage.getItem('dominItem')).defaultImg

      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: 1,pageNum: 1, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: 1, pageNum: this.newsPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {




        res.rows.map(r=>{
          // r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows

        this.newsTotal = res.total
      })
    },
  }
};
</script>

<style scoped lang="scss">
.baseball-article-page {
  display: flex;
  gap: 30px;
  padding: 20px;

  .article-main {
    flex: 1;

    .article-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .article-meta {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .author-logo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }

      .meta-info {
        .author {
          font-weight: bold;
          display: block;
        }

        .publish-date {
          font-size: 14px;
          color: #666;
        }
      }
    }



    .photo-credit {
      font-size: 12px;
      color: #999;
      margin-bottom: 20px;
    }

    .article-content {
      line-height: 1.6;
    }
  }

  .sidebar {
    width: 300px;

    .sidebar-title {
      text-align: center;
      font-size: 15px;
      background: #000;
      color: #ffffff;
      line-height: 35px;
      font-weight: bold;
      margin-bottom: 15px;
      padding-left: 15px;
      border-radius: 10px;
      border-bottom: 2px solid #000;
    }

    .latest-post {
      .post-thumbnail {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }

      .post-title {
        font-size: 16px;
        margin-bottom: 5px;
      }

      .post-date {
        font-size: 14px;
        color: #D9B433;
      }
    }
  }
}

.logo {
  padding: 10px;
  box-sizing: border-box;
  font-size: 40px;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 15%;
  min-height: 50px;
  background: #000;
  margin-bottom: 30px;
  color: #fff;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 500;
    font-size: 14px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    border-bottom: 3px solid #D4AF37;
    color: #D4AF37;
    transition: all .1s ease;
  }

  .choose {
    border-bottom: 3px solid #D4AF37;
    transition: all .1s ease;
    color: #D4AF37;
  }
}

.buttom {
  width: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  border: 1px solid #000000;

  .logo {
    width: auto;
  }
  display: flex;
  .explore {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 30px;
    margin-bottom: 30px;
    span {
      margin-right: 10px;
      text-align: center;
      font-size: 15px;
      color: #A6AEB1;
      display: inline-block;
      width: 20%;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.temp1, .temp2, .temp3 {
  justify-content: space-between;
}

.line1 {
  width: 80%;
  border-bottom: 1px solid #838383;
  margin: 0 10% 20px;
}

.time {
  color: rgba(0, 0, 0, .44);
  margin: 10px 0 20px;
  white-space: nowrap;
  line-height: 26px;
  font-weight: 400;
  font-size: 18px;
  align-items: center;
  display: flex;

  span:last-child {
    font-weight: 700;
    color: #4d4d4d;
    margin-left: 10px;
  }

  img {
    height: 20px;
  }
}

.article-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 10px;
}

.detail {
  font-weight: 400;
  line-height: 32px;
  font-size: 18px;
  color: #222222;
  margin-top: 20px;
}
</style>